import { InfoTooltip } from "./InfoTooltip";

interface ActivationParameters {
    minUsers: number;
    minHours: number;
    minDays: number;
    minFutureHours: number;
}

interface ActivationVariablesTileProps {
    activationParameters: ActivationParameters | undefined;
}

interface ActivationVariableItem {
    label: string;
    value: string;
}

export const ActivationVariablesTile = ({ activationParameters }: ActivationVariablesTileProps) => {
    const variables: ActivationVariableItem[] = [
        { label: "Assigned People", value: `≥ ${activationParameters?.minUsers ?? 8}` },
        { label: "Scheduled Hours", value: `≥ ${activationParameters?.minHours ?? 320}` },
        { label: "Scheduled Days", value: `≥ ${activationParameters?.minDays ?? 5}` },
        { label: "Future Hours Ratio", value: `≥ ${activationParameters?.minFutureHours ?? 80}%` },
    ];

    return (
        <div className="act-section">
            <div className="sec-hdr">Activation Definition</div>
            <div className="act-card">
                <div className="act-card-header">
                    <h4>
                        Activation Variables <span>v1</span>
                    </h4>
                    <InfoTooltip text="Current thresholds from PostHog (people assigned, scheduled hours, days, and future hours ratio)." />
                </div>
                <div className="vp">
                    {variables.map(({ label, value }) => (
                        <div key={label} className="vp-i">
                            <span className="vl">{label}</span>
                            <span className="vv mono">{value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
